import React, {useEffect, useState} from 'react';
import {Box, Button, HStack, Img, Link, Spinner, Stack, Text} from '@chakra-ui/react';
import colorAlpha from 'color-alpha';
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import axios from "axios";

const All = ({podcastType, startIndex, setStartIndex, pageCount, podcastsRef, podcastCount, hasNewsData}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [url, setUrl] = useState('')
    const navigate = useNavigate();
    const [loading, setIsLoading] = useState(false)
    const [podcastData, setPodcastData] = useState(undefined)
    const {slug} = useParams();
    const selectedTab = searchParams.get('tab');
    

    useEffect(() => {
        // console.log('page count', podcastType, podcastCount, startIndex)
        const abortController = new AbortController();
        const endpoints = {
            all: `/wp-admin/admin-ajax.php?action=get_insights&insights_start=${startIndex}&insights_include_podcasts=yes&author_slug=${slug}`,
            podcast: `/wp-admin/admin-ajax.php?action=get_insights&insights_start=${startIndex}&insights_include_podcasts=only&author_slug=${slug}`,
            perspectives: `/wp-admin/admin-ajax.php?action=get_insights&insights_start=${startIndex}&insights_include_podcasts=no&author_slug=${slug}`
        }
        const fetchPodcastData = async () => {
            if (url && !url.includes(podcastType)) {
                setStartIndex(pageCount || 0)
            }
            setIsLoading(true)
            setUrl(endpoints[podcastType])
            const response = await axios.get(endpoints[podcastType], {signal: abortController.signal}).then(resp => {
                return resp.data.items;
            }).catch(e => {
                
            });
            setPodcastData(response)
            setIsLoading(false)
            if(selectedTab) {
                scrollToPodcasts();
            }
        }
        fetchPodcastData()
        return () => {
            abortController.abort();
        }
    }, [slug, podcastType, startIndex, url])

    const scrollToPodcasts = () => {
        setTimeout(function() {
            const filters = document.getElementById("podcasts-perspectives");
            // console.log('filters', filters)
            window.scrollTo({
                top: filters.offsetTop - 20,
                behavior: "smooth"
            });
        }, 250);
    }

    return (
        <>
            {!podcastData ?
                (
                    <Box my={20} width="100%" textAlign="center">
                        <Spinner color='blue.600' size='xl'/>
                    </Box>
                )
                : (
                    <>
                    <Box
                        borderRight={{base: 'none', md: hasNewsData ? '1px solid #A1B6E5' : 'none'}}
                        pr={{base: '0', md: '21px'}}
                        className={'bio-perspectives-controls'}
                    >
                        {podcastData.length < 1 ? "No results match" : podcastData?.map((data, key) => (
                            <AllItem key={key} data={data} hasNewsData={hasNewsData}/>
                        ))}
                    </Box>
                    <Box>
                        <HStack spacing='24px'>
                            {startIndex > 1 &&
                                <Button
                                    size={'sm'}
                                    py={'18px'}
                                    minW={'100px'}
                                    textColor={'black'}
                                    fontWeight={'semibold'}
                                    fontSize={'xs'}
                                    variant={'brand'}
                                    borderRadius={'full'}
                                    colorScheme={'brand'}
                                    borderColor={'rgba(11, 46, 251, 0.5)'}
                                    onClick={() => {
                                        scrollToPodcasts()
                                        setStartIndex(startIndex - 5)
                                        navigate(startIndex ? `/teammember/${slug}/page/${startIndex - 5}${(selectedTab ? `?tab=${selectedTab}`: '')}` : `/teammember/${slug}${(selectedTab ? `?tab=${selectedTab}`: '')}`);
                                    }}
                                >
                                    Previous
                                </Button>
                            }
                            {podcastCount > parseInt(startIndex.toString()) + 5 &&
                                <Button
                                    size={'sm'}
                                    py={'18px'}
                                    minW={'100px'}
                                    textColor={'black'}
                                    fontWeight={'semibold'}
                                    fontSize={'xs'}
                                    variant={'brand'}
                                    borderRadius={'full'}
                                    colorScheme={'brand'}
                                    borderColor={'rgba(11, 46, 251, 0.5)'}
                                    onClick={() => {
                                        scrollToPodcasts()
                                        setStartIndex(parseInt(startIndex.toString()) + 5)
                                        navigate(`/teammember/${slug}/page/${parseInt(startIndex.toString()) + 5}${(selectedTab ? `?tab=${selectedTab}`: '')}`);
                                    }}
                                >
                                    Next
                                </Button>
                            }
                            {(!podcastData || loading) && (
                                <Box my={20} width="100%" textAlign="center">
                                    <Spinner color='blue.600' size='sm'/>
                                </Box>
                            )}
                        </HStack>
                    </Box>
                    </>)}
        </>
    );
};

export default All;

const AllItem = ({data, hasNewsData}) => {
    return (
        <Link href={data?.url} _hover={{textDecoration: 'none'}}>
            <Box pb={'20px'} mb={'20px'} borderBottom={'1px solid #A1B6E5'}>
                <Stack mb={'13px'} spacing={'17px'} direction={'row'} align={'center'}>
                    <Img
                        w={'60px'}
                        h={'60px'}
                        alt={'profile-avatar'}
                        borderRadius={'full'}
                        src={data?.author_photo}
                    />
                    <Text fontSize={'16px'} lineHeight={'32px'} color={'brand.700'}>
                        {data?.author_name}
                    </Text>
                </Stack>
                <Text
                    mb={'20px'}
                    fontSize={'24px'}
                    lineHeight={'28.8px'}
                    letterSpacing={'-0.01em'}
                    maxW={{base: '100%', lg: '75%'}}
                    overflow={'hidden'}
                    textOverflow={'ellipsis'}
                    whiteSpace={'nowrap'}
                >
                    {data?.post_title}
                </Text>
                <Box
                    maxW={{base: '100%', lg: '75%'}}
                    fontSize={'16px'}
                    lineHeight={'16.8px'}
                    letterSpacing={'-0.01em'}
                    noOfLines={3}
                    color={colorAlpha('#000000', 0.5)}
                    mb={'23px'}
                    height={'50.39px'}
                >
                    
                    <div dangerouslySetInnerHTML={{__html: data?.post_excerpt}}/>
                </Box>
                <Text fontSize={'12px'} lineHeight={'13.2px'} color={colorAlpha('#000000', 0.5)}>
                    {data?.post_date}
                </Text>
            </Box>
        </Link>
    );
};
